export const APP_NAME = 'OG2Speckle'
export const AUTH_STORE_KEY = 'useAuthStore'
